<template>
  <vs-col vs-lg="6" vs-xs="12" class="p-1" id="servicePieChart"  style="margin-bottom: 20px">
    <vs-card :id="headerTitle.replaceAll(' ','')" class="vs-con-loading__container" style="width:100%; height:100%">
      <div :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" style="width: 100%" slot="header">
        <h3>
          {{headerTitle}}
        </h3>
      </div>
      <br>
      <br>
      <div style="min-height: 100px" class="col" id="chart-timeline">
        <div v-if="isLoading" style="display: flex;width: 100%;justify-content: center;height: 100px">
          <div class="spinner-border text-primary" style="margin: auto" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <vue-apex-charts v-if="servicePie.series.length" height="350" ref="servicePieChart" :options="servicePie.chartOptions" :series="servicePie.series ? servicePie.series : []"></vue-apex-charts>
      </div>
      <br>
    </vs-card>
  </vs-col>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { statisticsService } from "../../_services";

export default {
  name: "Service-Pie-Chart",
  data:() => ({
    monthRange: null,
    servicePie : null,
    servicePieParams : {
      periodical : ""
    },
    isLoading: false,
  }),
  components:{
    VueApexCharts,
  },
  watch: {
    startLoading(newValue) {
      if(newValue) {
        this.isLoading = true;
        this.changeFilterRanged(this.dateRange);
      }
    }
  },
  emits: ['doneLoading'],
  props:{
    startLoading: Boolean,
    dateRange: Array,
    headerTitle : String,
    businessList: Array,
  },
  methods : {
    changeFilterRanged(monthRange) {
      this.monthRange = monthRange;
      this.$emit("updateDateRange", monthRange);
      this.loadStatistics();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = date.getDate().toString().padStart(2, '0');
      return`${year}-${month}-${day}`;
    },
    getStartDate(month) {
      const [year, monthPart] = month.split('-');
      const startDate = new Date(`${year}-${monthPart}-01 00:00:00`);
      return this.formatDate(startDate);
    },
    getEndDate(month) {
      const [year, monthPart] = month.split('-');
      const lastDay = new Date(year, monthPart, 0);
      const endDate = new Date(`${year}-${monthPart}-${lastDay.getDate()} 23:59:59`);
      return this.formatDate(endDate);
    },
    setupChart() {
      this.servicePie = {
        series: [],
        chartOptions: {
          chart: {
            width: 380,
            type: 'pie',
          },
          title : {
            align: 'center',
            margin: 10,
            floating: true,
            style: {
              fontSize:  '18px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          },
          legend :{
            show: true,
            position: 'bottom'
          },
          labels: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      };
    },
    loadStatistics() {

      this.setupChart();
      if(this.businessList.length > 0) {
        this.servicePieParams.business_id = this.businessList.map(business => { return business.id; }).toString();
      }
      this.servicePieParams.start = this.getStartDate(this.monthRange[0]);
      this.servicePieParams.end = this.getEndDate(this.monthRange[1]);
      statisticsService.serviceFrequency(this.servicePieParams).then(function (data) {
        this.servicePie.series = data.services.data;
        this.servicePie.chartOptions.labels = data.services.labels;
      }.bind(this)).finally(() => {
        this.isLoading = false;
        this.$emit('doneLoading')
      })
    }
  },
  mounted(){
    this.setupChart();
  }
}
</script>

<style>

</style>